<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">The Secret Sign</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#id_Toc168649515">Glossary of RomanPlace Namesfor‘The Secret Sign’</a></li>
<li><a href="#/index_split_004#id_Toc168649516">Chapter 1: The Search for Power</a></li>
<li><a href="#/index_split_005#id_Toc168649517">Chapter 2: The Door Opens</a></li>
<li><a href="#/index_split_006#id_Toc168649518">Chapter 3: Spectacle at the Arena</a></li>
<li><span href="#/index_split_007#id_Toc168649519" title="Link target outside of Sample">Chapter 4: Inside the House</span></li>
<li><span href="#/index_split_008#id_Toc168649520" title="Link target outside of Sample">Chapter 5: Trouble for Zara</span></li>
<li><span href="#/index_split_009#id_Toc168649521" title="Link target outside of Sample">Chapter 6: Master’s Response and a Crisis</span></li>
<li><span href="#/index_split_010#id_Toc168649522" title="Link target outside of Sample">Chapter 7: Escape from a Burning Rome</span></li>
<li><span href="#/index_split_011#id_Toc168649523" title="Link target outside of Sample">Chapter 8: On the High Seas</span></li>
<li><span href="#/index_split_012#id_Toc168649524" title="Link target outside of Sample">Chapter 9: A Shipwreck and a Surprise</span></li>
<li><span href="#/index_split_013#id_Toc168649525" title="Link target outside of Sample">Chapter 10: Island Adventure</span></li>
<li><span href="#/index_split_014#id_Toc168649526" title="Link target outside of Sample">Chapter 11: Peace—and Disaster</span></li>
<li><span href="#/index_split_015#id_Toc168649527" title="Link target outside of Sample">Chapter 12: Where is Rufus?</span></li>
<li><span href="#/index_split_016#id_Toc168649528" title="Link target outside of Sample">Chapter 13: Punishment—and New Arrivals</span></li>
<li><span href="#/index_split_017#id_Toc168649529" title="Link target outside of Sample">Chapter 14: The Big Freeze—and its Aftermath</span></li>
<li><span href="#/index_split_018#id_Toc168649530" title="Link target outside of Sample">Chapter 15: The Runaways</span></li>
<li><span href="#/index_split_019#id_Toc168649531" title="Link target outside of Sample">Chapter 16: On the way to Verulamium</span></li>
<li><span href="#/index_split_020#id_Toc168649532" title="Link target outside of Sample">Chapter 17: The Search</span></li>
<li><span href="#/index_split_021#id_Toc168649533" title="Link target outside of Sample">Chapter 18: A Surprising Discovery</span></li>
<li><span href="#/index_split_022#id_Toc168649534" title="Link target outside of Sample">Chapter 19: What became of Andreas?</span></li>
<li><span href="#/index_split_023#id_Toc168649535" title="Link target outside of Sample">Chapter 20: Dead or Alive?</span></li>
<li><span href="#/index_split_024#id_Toc168649536" title="Link target outside of Sample">Chapter 21: The Stowaway</span></li>
<li><span href="#/index_split_025#id_Toc168649537" title="Link target outside of Sample">Chapter 22: Flavia hears the News</span></li>
<li><span href="#/index_split_026#id_Toc168649538" title="Link target outside of Sample">Chapter 23: Andreas flees back to Rome</span></li>
<li><span href="#/index_split_027#id_Toc168649539" title="Link target outside of Sample">Chapter 24: Gaius returns home</span></li>
<li><span href="#/index_split_028#id_Toc168649540" title="Link target outside of Sample">Chapter 25: Andreas finds life hard</span></li>
<li><span href="#/index_split_029#id_Toc168649541" title="Link target outside of Sample">Chapter 26: Zara’s Quest</span></li>
<li><span href="#/index_split_030#id_Toc168649542" title="Link target outside of Sample">Chapter 27: Rebekah’s Story and a Shock</span></li>
<li><span href="#/index_split_031#id_Toc168649543" title="Link target outside of Sample">Chapter 28: Sailing Home</span></li>
<li><span href="#/index_split_032#id_Toc168649544" title="Link target outside of Sample">Chapter 29: The End of it All—or New Beginnings</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5e5f1dde